import { render, staticRenderFns } from "./SettingEditTabInvoice.vue?vue&type=template&id=b9e6a20e&"
import script from "./SettingEditTabInvoice.vue?vue&type=script&lang=js&"
export * from "./SettingEditTabInvoice.vue?vue&type=script&lang=js&"
import style0 from "./SettingEditTabInvoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports